// removed by extract-text-webpack-plugin
module.exports = {"currencySelect":"_1NOOBtxPRkv2PLCK3DZz8x"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/snapsell/CurrencySelect.scss
// module id = 1587
// module chunks = 0